/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SoftwareReportsControlEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const softwareReportsControlEntrypoint: EntryPoint<
	SoftwareReportsControlEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<SoftwareReportsControlEntrypointComponent>(
		/* webpackChunkName: "async-software-reports-control-entrypoint" */ './ExportedComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
